import React from 'react';

export default function ExcelFileIcon(props) {
  return (
    <svg width='24' height='24' {...props} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.8 3H13.0716C13.5388 3 13.9877 3.18163 14.3234 3.50652L20.4518 9.43719C20.8022 9.77629 21 10.243 21 10.7307V19.2C21 20.1941 20.1941 21 19.2 21H4.8C3.80589 21 3 20.1941 3 19.2V4.8C3 3.80589 3.80589 3 4.8 3Z'
        stroke='#208020'
        strokeWidth='2'
      />
      <path d='M8 9L15 16M8 16L15 9' stroke='#208020' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
}
